import { Component, Input } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { OverdriveProvider } from '../../providers/overdrive/overdrive';
/**
 * Generated class for the CoDiscoverItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-discover-item',
  templateUrl: 'co-discover-item.html'
})
export class CoDiscoverItemComponent {

  coverUrl: Object;
  @Input() update: Observable<Array<number>>;
  @Input() item: any;
  constructor(private bib:CoBibItemProvider, private overdrive: OverdriveProvider) {

  }
  ngOnInit(){
    // this.update = Observable.fromEvent(this.container, 'scroll');
    // //map to string with given event timestamp
    // const example = source.map(event => `Event time: ${event.timeStamp}`);
    // //output (example): 'Event time: 7276.390000000001'
    // const subscribe = example.subscribe(val => console.log(val));

  }
  ngOnChanges() {

    this.coverUrl = this.getCoverUrl(this.item);
    // this.coverUrl={};
    // this.timer = setTimeout(()=>{
    //   this.coverUrl = this.getCoverUrl(this.item);
    // }, 650);
    // console.time(this.coverUrl.src);
  }
  ngOnDestroy(){
    // if(this.timer)clearTimeout(this.timer);
    // console.timeEnd(this.coverUrl.src);
  }
  showItem(){
    if(this.item.ids){
        const m = this.item.ids.reduce((ret,id)=>{
            if(!ret[id.n])ret[id.n]=[];
            ret[id.n].push(id.v);
            return ret;
        }, {});
        if(m.ILS && m.ILS.length>0){
            this.bib.showItemFromBibId(m.ILS[0]);
        }else if(m.ISBN && m.ISBN.length>0){
            this.bib.showItemFromISBN(m.ISBN[0]);
        }else if(m.UPC && m.UPC.length>0){
            this.bib.showItemFromUPC(m.UPC[0]);
        }
    }else if(this.item.src==='overdrive'){
        this.overdrive.getItemDetailsFromGUID(this.item.objectID).then(item=>{
            if(item.isbns.length>0){
                // console.log(item.isbns[0]);
                this.bib.showItemFromISBN(item.isbns[0]);
            }
        });
    }else{
        console.log('No useable ids',this.item);
        alert('No useable ids');
    }
  }
  getCoverUrl(hit):Object{
    // if(hit.cover)return hit.cover;
    let p;
    let id;
    if(hit.src==='overdrive'){
        p="overdrive";
        id=hit.objectID;
    }
    if(hit.ids){
        const m = hit.ids.reduce((ret,id)=>{
            if(!ret[id.n])ret[id.n]=[];
            ret[id.n].push(id.v);
            return ret;
        }, {});

        if(m.ISBN && m.ISBN.length>0){
            p="isbn";
            id=m.ISBN[0];
        }
        if(m.UPC && m.UPC.length>0){
            p="upc";
            id=m.UPC[0];
        }
        if(hit.objectID.endsWith('IndieFlix')){
            p="indieflix";
            id=m.MARC[0];
        }
        if(hit.objectID.endsWith('ComicsPlus')){
            p="comicsplus";
            id=m.MARC[0];
        }
        if(hit.objectID.endsWith('Hoopla')){
            p="hoopla";
            id=m.MARC[0];
        }
    }
    if(p && id){
        const server = Math.floor(Math.random() * 9);
        return {
            loading:'http://covers' + server + '.communico.co/'+p+'/l/'+id+'.jpg',
            src:'http://covers' + server + '.communico.co/'+p+'/o/'+id+'.jpg',
            error:`http://covers${server}.communico.co/gen/cover?title=`+encodeURIComponent(hit.ti)
//            error:"http://placehold.it/100x150&text="+encodeURIComponent(hit.ti)
        }
    }else{
        const server = Math.floor(Math.random() * 9);
        return {src:`http://covers${server}.communico.co/gen/cover?title=`+encodeURIComponent(hit.ti), error:'http://placehold.it/100x150/8b6e6e/000000?text=Error'};
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-discover-item/co-discover-item.ts